import { PlayerBalance } from '@app/models/player-balance';
import { Ticket } from '@app/models/ticket';
import { createAction, props } from '@ngrx/store';

export const addMany = createAction('[Tickets] Add Many Tickets', props<{ tickets: Ticket[] }>());
